import React from "react";
import { Image, View } from "react-native";
import aggregator from "@/assets/aggregator.png";
import driveThru from "@/assets/drive-thru.png";
import { tposModeIconStyles as styles } from "./styles";
import { TposMode } from "@/app/types/mode";

const TposModeIcon = (): JSX.Element => {
  const tposMode = TposMode.DRIVE_THRU; // useSelector(getTposMode);
  const modeIcon = tposMode === TposMode.DRIVE_THRU ? driveThru : aggregator;

  return (
    <View testID="tposModeIcon" style={styles.container}>
      <Image style={styles.icon} resizeMode="contain" source={modeIcon} />
    </View>
  );
};

export default TposModeIcon;
